/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';
import { zIndex } from 'blb-styles/zIndex';
import { Logo } from '../common/Logo/Logo';

const headerHeight = 48;

const minimizedWidth = 260;

const styles = StyleSheet.create({
  wrapper: {
    height: headerHeight,
    justifyContent: 'space-between',
    display: 'flex',
    width: '100%',
    backgroundColor: colors.white,
    boxShadow: `0 0 4px 0 ${mixins.rgba(0, 0, 0, 0.12)}`,
    minWidth: minimizedWidth,
  },
  header: {
    position: 'relative',
    zIndex: zIndex.header,
    top: 0,
    left: 0,
    height: headerHeight,
  },
  headerMenu: {
    color: colors.clayPlus3,
    paddingRight: 48,
    lineHeight: 0,
    zIndex: zIndex.headerDropdownIcon,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    marginTop: 4,
    marginBottom: 4,
  },
  linksWrapper: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },
  noListStyle: {
    padding: 0,
    listStyleType: 'none',
    margin: 0,
    display: 'flex',
    height: '100%',
  },
  noListItemStyle: {
    margin: 0,
    padding: 0,
  },
  buttonWrapper: {
    padding: 0,
    border: 'none',
    background: 'none',
    boxShadow: 'none',
    height: '100%',
  },
});

export namespace DesktopHeader {
  export interface HeaderLink {
    display: string;
    handleClick: () => void;
  }

  export interface Props {
    headerLinks: HeaderLink[];
  }
}

export const DesktopHeader: React.FC<DesktopHeader.Props> = ({ headerLinks }) => {
  return (
    <header className={css(styles.header)} data-it="DesktopHeader">
      <div className={css(styles.wrapper)}>
        <Logo />
        <div className={css(styles.headerMenu)} data-it="desktopHeaderMenu">
          <nav className={css(styles.linksWrapper)}>
            <ul className={css(styles.noListStyle)}>
              {headerLinks.map(headerLink => {
                return (
                  <li className={css(styles.noListItemStyle)} key={headerLink.display}>
                    <button
                      className={css(styles.buttonWrapper)}
                      data-it={`${headerLink.display}-Button`}
                      onClick={headerLink.handleClick}
                    >
                      {headerLink.display}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};
